const invertedMessages = {
  Count: 'external.dashboard.donutChart.tooltip.count',
  Percentage: 'external.dashboard.donutChart.tooltip.percentage',
};

export default invertedMessages;
